import { render, staticRenderFns } from "./CardItemPlantaAbateLotes.vue?vue&type=template&id=6d784d4e&scoped=true&"
import script from "./CardItemPlantaAbateLotes.vue?vue&type=script&lang=js&"
export * from "./CardItemPlantaAbateLotes.vue?vue&type=script&lang=js&"
import style0 from "./CardItemPlantaAbateLotes.vue?vue&type=style&index=0&id=6d784d4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d784d4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VContainer,VFlex,VHover,VItem,VItemGroup,VLayout,VOverlay,VRow,VSheet})
